import styled, { css } from 'styled-components';

export const Main = styled.main`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-template-columns: 100%;
    grid-auto-rows: max-content;
    grid-gap: ${spacing.km12};
    justify-items: center;
  `}
`;
